import type { ApiService } from '@/core/http/services/ApiService'
import type { AxiosResponse } from 'axios'
import type { VtOrderResponse, VtOrderRowRequest } from '@/core/http/services/vt-orders/types'

export default class VtOrderRowService {
  constructor(private readonly service: ApiService) {
    //
  }

  private path(orderId: number, id: number | null = null): string {
    return [`/api/vt-orders/${orderId}/rows`, id].filter(Boolean).join('/')
  }

  async store(
    orderId: number,
    request: VtOrderRowRequest,
  ): Promise<AxiosResponse<VtOrderResponse>> {
    return await this.service.client.post(this.path(orderId), request)
  }

  async update(
    orderId: number,
    id: number,
    request: VtOrderRowRequest,
  ): Promise<AxiosResponse<VtOrderResponse>> {
    return await this.service.client.put(this.path(orderId, id), request)
  }

  async destroy(orderId: number, id: number): Promise<AxiosResponse<VtOrderResponse>> {
    return await this.service.client.delete(this.path(orderId, id))
  }
}
